import { render, staticRenderFns } from "./CarCardMoveTable.vue?vue&type=template&id=fe8270fa&scoped=true"
import script from "./CarCardMoveTable.vue?vue&type=script&lang=ts"
export * from "./CarCardMoveTable.vue?vue&type=script&lang=ts"
import style0 from "./CarCardMoveTable.vue?vue&type=style&index=0&id=fe8270fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8270fa",
  null
  
)

export default component.exports